import { LookupItem } from "../models/lookup-item";
import { LookupValue } from "./lookup-value";


export class SponsorDetails {
  title: LookupItem | null = null;
  titleOther = '';
  firstName = '';
  surname = '';
  email = '';
  phoneType = '';
  phoneCountryCode = '';
  phoneAreaCode = '';
  phoneNumber = '';
  passportCountry: LookupItem | null = null;
  dob = '';
  hasPartner = '';
  partnerName = '';
  partnerSurname = '';
  partnerDob = '';
  hasHealthCondition = false;
  healthDetails: any[] = [];
  hasBeenConvicted = false;
  convictionDetails: any[] = [];
  assurers: any[] = [];
  countryResidence:LookupValue | null = null;
  previouslySponsored = '';
  howManyPreviously = '';
  employmentStatus: LookupItem | null = null;
  visaStatus: LookupItem | null = null;
  maritalStatus: LookupItem | null = null;
  realtionToApplicant: LookupItem | null = null;
}